import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { LinkWeb, LinKWebMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LinkWebFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => LinkWebFormComponent),
    },
  ],
  selector: 'app-link-web-form',
  styleUrls: ['./link-web-form.component.scss'],
  templateUrl: './link-web-form.component.html',
})
export class LinkWebFormComponent extends BaseCtrlValueAccessorFormArrayComponent<LinkWeb> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage without a control');
    }

    const control = this.formManager.makeForm(LinKWebMeta, {} as LinkWeb);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage without a control');
    }

    this.form.removeAt(index);
  }

}
